module.exports = __webpack_public_path__ + "img/499577-2.57c2958f.png";